module.exports = new __parcel__URL__("mapIcon.288aa78b.svg").toString();